// import grantThorntonLogo from "/assets/icons/grant-thornton-logo.png";
import grantThorntonLogo from "/assets/icons/infinitibit-logo.png";
const steps = [
  { n: "1", text: "Select any text in your Word document" },
  { n: "2", text: "Choose a quick action or describe your changes" },
  { n: "3", text: "Review suggestions and apply to your document" },
];

const NoSelectionState = () => {
  return (
    <div
      className="flex flex-col items-center justify-center py-8 px-5 text-center h-full animate-fade-in"
      role="status"
    >
      {/* Logo */}
      <div className="mb-5 opacity-90 hover:opacity-100 transition-opacity">
        <img
          src={grantThorntonLogo}
          alt="Grant Thornton"
          className="h-9 w-auto object-contain"
        />
      </div>

      {/* Icon + Headline */}
      {/* <div className="w-12 h-12 rounded-2xl flex items-center justify-center mb-4 shadow-[0_4px_20px_-4px_rgba(59,130,246,0.3)]" style={{ background: "linear-gradient(135deg, #3B82F6 0%, #1D4ED8 100%)" }}>
        <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
          <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      </div> */}

      <h3 className="text-base font-bold text-gray-900 mb-1.5 tracking-tight">
        AI-Powered Editing
      </h3>
      <p className="text-xs text-gray-500 mb-6 max-w-[220px] leading-relaxed">
        Highlight text in your document to improve clarity, adjust tone, or rewrite with AI.
      </p>

      {/* Steps card */}
      <div className="w-full bg-white border border-gray-100 rounded-xl p-4 shadow-sm text-left">
        <div className="flex items-center gap-2 mb-3">
          <div className="w-1.5 h-1.5 rounded-full bg-brand-500 animate-pulse-soft" />
          <span className="text-[10px] font-bold text-gray-400 uppercase tracking-widest">
            How to start
          </span>
        </div>
        <ul className="space-y-2.5">
          {steps.map(({ n, text }) => (
            <li key={n} className="flex items-start gap-2.5">
              <span className="flex-shrink-0 w-5 h-5 rounded-md bg-brand-50 border border-brand-100 flex items-center justify-center text-[10px] font-bold text-brand-500 leading-none">
                {n}
              </span>
              <span className="text-xs text-gray-600 leading-relaxed pt-0.5">{text}</span>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default NoSelectionState;
